import React, { useState, useEffect } from 'react';
import chevronup from '../../assets/img/chevron-up.svg';
import threedots from '../../assets/img/three-dots-vertical.svg';
import chevrondown from '../../assets/img/chevron-down.svg';
import eyeimg from '../../assets/img/eye.svg';
import searchimg from '../../assets/img/search.svg';
import downloadimg from '../../assets/img/download.svg';
import SignatureLogDetails from './SignatureLogDetails';
import { fetchApi } from "../../api";
import auditLogDecryption from '../../utils/auditLogDecryption';
import * as XLSX from "xlsx";

function AuditLog() {
  const [allLogs, setAllLogs] = useState([]);
  const [allEmployees, setAllEmployees] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [isLoadingLogs, setIsLoadingLogs] = useState(false);

  useEffect(() => {
    loadAuditLogs();
  }, []);

  const loadAuditLogs = async () => {
    try {
      const res = await fetchApi('/api/auditlog/all');
      console.log('Raw auditlog response:', JSON.stringify(res).slice(0, 500));
      const logs = Array.isArray(res) ? res : (res?.data || res?.logs || res?.auditLogs || res?.result || []);
      console.log('API Response logs:', logs.slice(0, 2));
      setAllLogs(logs);
      const seen = new Map();
      const unique = [];
      logs.forEach((log, i) => {
        const key = log.esl_salary_code;
        if (key && !seen.has(key)) {
          seen.set(key, true);
          console.log('Log fields for', key, ':', Object.keys(log));
          unique.push({
            srno: unique.length + 1,
            es_salary_code: key,
            es_name: log.esl_name || '',
            empDivisionCode: log.esl_division_code || '',
            empDepartmentCode: log.esl_function || '',
            empBandCode: log.esl_band || '',
          });
        }
      });
      setAllEmployees(unique);
      setEmployees(unique);
    } catch (error) {
      console.error('Failed to load audit logs:', error);
    }
  };

 const [divisions] = useState([]);
  const [departments] = useState([]);
  const [bands] = useState([]);


  const [selectedDivision, setSelectedDivision] = useState('Select');
  const [selectedDepartment, setSelectedDepartment] = useState('Select');
  const [selectedBand, setSelectedBand] = useState('Select');
  const [searchEmpCode, setSearchEmpCode] = useState('');
  const [searchEmpName, setSearchEmpName] = useState('');
  const [showPopUp, setShowPopUp] = useState('0');
  const [popUpData, setPopUpData] = useState('');
  const [popSearchDivcode, setPopSearchDivcode] = useState('');
  const [popSearchDeptcode, setPopSearchDeptcode] = useState('');
  const [popSearchBandcode, setPopSearchBandcode] = useState('');
  const [noRecords, setNoRecords] = useState(false);
  const [codeList, setCodeList] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [showLogDetails, setShowLogDetails] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");

  // Column filter state
  const [columnFilters, setColumnFilters] = useState({});
  const [activeFilter, setActiveFilter] = useState(null);
  const [filterDraft, setFilterDraft] = useState({ type: "Contains", value: "" });

  // Column resize state
  const [columnWidths, setColumnWidths] = useState({});
  const resizingCol = React.useRef(null);
  const startX = React.useRef(0);
  const startWidth = React.useRef(0);

  // Sorting state
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [hoveredCol, setHoveredCol] = useState(null);

  const godrejStyles = { primary: "#810055", secondary: "#707070", font: "GB-BodyCopy" };

  const tableColumns = [
    { key: "es_name", label: "Name" },
    { key: "es_salary_code", label: "Salary Code" },
    { key: "empDivisionCode", label: "Division" },
    { key: "empDepartmentCode", label: "Department" },
    { key: "empBandCode", label: "Band" },
  ];

  const updateFilterLive = (colKey, draft) => {
    setFilterDraft(draft);
  };

  const handleMouseDown = (e, colKey) => {
    e.preventDefault();
    resizingCol.current = colKey;
    startX.current = e.clientX;
    const th = e.target.parentElement;
    startWidth.current = th.offsetWidth;
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  const handleMouseMove = (e) => {
    if (!resizingCol.current) return;
    const diff = e.clientX - startX.current;
    const newWidth = Math.max(50, startWidth.current + diff);
    setColumnWidths(prev => ({ ...prev, [resizingCol.current]: newWidth }));
  };

  const handleMouseUp = () => {
    resizingCol.current = null;
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
  };

  const handleSort = (colKey) => {
    setSortConfig(prev => ({
      key: colKey,
      direction: prev.key === colKey && prev.direction === "asc" ? "desc" : "asc"
    }));
  };

  const applyColumnFilter = (colKey) => {
    if (filterDraft.value || filterDraft.type === "Blank" || filterDraft.type === "Not Blank") {
      setColumnFilters(prev => ({ ...prev, [colKey]: { ...filterDraft } }));
    }
    setActiveFilter(null);
    setCurrentPage(0);
  };

  const resetColumnFilter = (colKey) => {
    setColumnFilters(prev => { const n = { ...prev }; delete n[colKey]; return n; });
    setFilterDraft({ type: "Contains", value: "" });
    setActiveFilter(null);
    setCurrentPage(0);
  };

  const matchesColumnFilter = (val, filter) => {
    const cellVal = String(val || "").toLowerCase();
    const filterVal = (filter.value || "").toLowerCase();
    switch (filter.type) {
      case "Contains": return cellVal.includes(filterVal);
      case "Not Contains": return !cellVal.includes(filterVal);
      case "Equals": return cellVal === filterVal;
      case "Not Equals": return cellVal !== filterVal;
      case "Starts With": return cellVal.startsWith(filterVal);
      case "Ends With": return cellVal.endsWith(filterVal);
      case "Blank": return cellVal.trim() === "";
      case "Not Blank": return cellVal.trim() !== "";
      default: return true;
    }
  };

  const getCellValue = (emp, key) => emp[key] || "";

  const filteredEmployees = employees.filter(emp => {
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      const matches = tableColumns.some(col => String(getCellValue(emp, col.key) || "").toLowerCase().includes(term));
      if (!matches) return false;
    }
    for (const [colKey, filter] of Object.entries(columnFilters)) {
      if (!matchesColumnFilter(getCellValue(emp, colKey), filter)) return false;
    }
    return true;
  }).sort((a, b) => {
    if (!sortConfig.key) return 0;
    const aVal = String(getCellValue(a, sortConfig.key) || "").toLowerCase();
    const bVal = String(getCellValue(b, sortConfig.key) || "").toLowerCase();
    if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
    if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  const numberOfPages = () => Math.ceil(filteredEmployees.length / pageSize);

  const handleDownload = () => {
    const exportData = filteredEmployees.map(emp => ({
      "Name": emp.es_name,
      "Salary Code": emp.es_salary_code,
      "Division": emp.empDivisionCode,
      "Department": emp.empDepartmentCode,
      "Band": emp.empBandCode,
    }));
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "AuditLog");
    XLSX.writeFile(wb, "AuditLogData.xlsx");
  };

  const setIndex = (type, popup) => {
    setPopUpData(type);
    setShowPopUp('1');
  };

  const closeClick = () => {
    setShowPopUp('0');
    setPopSearchDivcode('');
    setPopSearchDeptcode('');
    setPopSearchBandcode('');
  };

  const divisionClick = (divisionCode) => {
    setSelectedDivision(divisionCode);
    setShowPopUp('0');
  };

  const departmentClick = (departmentCode) => {
    setSelectedDepartment(departmentCode);
    setShowPopUp('0');
  };

  const bandClick = (bandCode) => {
    setSelectedBand(bandCode);
    setShowPopUp('0');
  };

  const getCandidates = () => {
    const div = selectedDivision && selectedDivision !== 'Select' && selectedDivision !== 'undefined' ? selectedDivision.toLowerCase() : '';
    const dept = selectedDepartment && selectedDepartment !== 'Select' && selectedDepartment !== 'undefined' ? selectedDepartment.toLowerCase() : '';
    const band = selectedBand && selectedBand !== 'Select' && selectedBand !== 'undefined' ? selectedBand.toLowerCase() : '';
    const code = searchEmpCode.trim().toLowerCase();
    const name = searchEmpName.trim().toLowerCase();

    const filtered = allEmployees.filter(emp => {
      if (div && (emp.empDivisionCode || '').toLowerCase() !== div) return false;
      if (dept && (emp.empDepartmentCode || '').toLowerCase() !== dept) return false;
      if (band && (emp.empBandCode || '').toLowerCase() !== band) return false;
      if (code && !(emp.es_salary_code || '').toLowerCase().includes(code)) return false;
      if (name && !(emp.es_name || '').toLowerCase().includes(name)) return false;
      return true;
    }).map((emp, i) => ({ ...emp, srno: i + 1 }));

    setEmployees(filtered);
    setCurrentPage(0);
  };

  const viewLog = async (salaryCode) => {
    const employee = employees.find(emp => emp.es_salary_code === salaryCode);
    // // Old approach - uses local allLogs (has encrypted objects)
    // const logs = allLogs.filter(log => log.esl_salary_code === salaryCode);
    // setSelectedEmployee({ ...employee, logs });
    // setShowLogDetails(true);
    
    // New approach - call API to get decrypted details for this employee
    setIsLoadingLogs(true);
    try {
      const res = await fetchApi('/api/auditlog/details', {
        method: 'POST',
        body: JSON.stringify({ salCode: salaryCode })
      });
      const logs = Array.isArray(res) ? res : (res?.data || []);
      setSelectedEmployee({ ...employee, logs });
      setShowLogDetails(true);
    } catch (error) {
      console.error('Failed to load log details:', error);
    } finally {
      setIsLoadingLogs(false);
    }
  };

  const backToList = () => {
    setShowLogDetails(false);
    setSelectedEmployee(null);
  };

  const filterValue = (event) => {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  };

  const filterValueName = (event) => {
    const inputValue = event.which ? event.which : event.keyCode;
    if (!(inputValue >= 65 && inputValue <= 122) && (inputValue !== 32 && inputValue !== 0)) {
      event.preventDefault();
    }
  };

  const getSearchCode = (searchValue, type) => {
    console.log('Search:', searchValue, 'Type:', type);
  };

  if (showLogDetails && selectedEmployee) {
    return <SignatureLogDetails employee={selectedEmployee} onBack={backToList} />;
  }

  return (
    <div className="tabs-content address-master" style={{ fontFamily: godrejStyles.font }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: '10px', marginBottom: '10px' }}>
        <h1 style={{ fontSize: "18px", fontWeight: "400", color: "#333", margin: "0" }}>Audit Log</h1>
        <div style={{ display: "flex", alignItems: "center" }}>
          <input 
            type="text" 
            placeholder="Search here..." 
            value={searchTerm}
            onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(0); }}
            style={{ 
              width: "250px", 
              height: "35px", 
              padding: "4px 34px", 
              border: "1px solid #ccc",
              borderRadius: "4px",
              fontSize: "14px",
              backgroundImage: `url(${searchimg})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "10px center",
              backgroundSize: "16px 16px"
            }} 
          />
          <img 
            src={downloadimg} 
            alt="Download" 
            title="Download" 
            onClick={handleDownload}
            style={{ 
              width: "20px", 
              height: "20px", 
              marginLeft: "15px",
              cursor: "pointer"
            }} 
          />
        </div>
      </div>

      {filteredEmployees.length !== 0 && (
        <div>
          {Object.keys(columnFilters).length > 0 && (
            <div className="filterList" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', padding: '5px 10px' }}>
              {Object.entries(columnFilters).map(([colKey, filter]) => {
                const col = tableColumns.find(c => c.key === colKey);
                return (
                  <div key={colKey} className="filter-col pr-0 me-2 mb-2" style={{ display: 'flex', alignItems: 'center', backgroundColor: '#F9F2F6', borderRadius: '25px', padding: '2px 8px', fontSize: '13px' }}>
                    <span className="ps-2 btn-text">{col?.label || colKey} : {filter.type === 'Blank' || filter.type === 'Not Blank' ? filter.type : filter.value}</span>
                    <div onClick={() => resetColumnFilter(colKey)} style={{ cursor: 'pointer', marginLeft: '4px' }}>
                      <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 16 16" height="25" width="25" xmlns="http://www.w3.org/2000/svg"><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path></svg>
                    </div>
                  </div>
                );
              })}
              <div>
                <button type="button" className="btn" style={{ backgroundColor: 'white', color: '#810055', border: '1px solid #810055', padding: '3px 15px', borderRadius: '25px', textTransform: 'none', fontSize: '14px', fontWeight: '500', marginLeft: '6px' }} onClick={() => { setColumnFilters({}); setCurrentPage(0); }}>Clear All</button>
              </div>
            </div>
          )}
          <div style={{ maxHeight: "400px", overflowY: "scroll", overflowX: "scroll", padding: "0px 0px 10px 10px", boxSizing: "border-box", backgroundColor: "#fff", marginTop: "5px" }}>
            <table className="table table-hover mb-0" style={{ width: "100%", minWidth: "900px", borderCollapse: "separate", borderSpacing: "0 3px" }}>
              <thead style={{ backgroundColor: godrejStyles.secondary, color: "#fff", fontSize: "0.9rem", position: "sticky", top: 0, zIndex: 2, verticalAlign: "top", height: "36px", fontWeight: "400", whiteSpace: "nowrap" }}>
                <tr>
                  {tableColumns.map(col => (
                    <th key={col.key} onMouseEnter={() => setHoveredCol(col.key)} onMouseLeave={() => setHoveredCol(null)} style={{ height: "36px", padding: "8px 10px", fontWeight: "400", whiteSpace: "nowrap", position: "relative", textAlign: "left", width: columnWidths[col.key] ? `${columnWidths[col.key]}px` : "auto", backgroundColor: godrejStyles.secondary, boxShadow: "0 -4px 0 0 #fff" }}>
                      <span style={{ cursor: "pointer", display: "flex", alignItems: "center" }}>
                        {col.label}
                        <img
                          src={chevronup}
                          alt="sort"
                          onClick={() => handleSort(col.key)}
                          style={{ width: "12px", height: "12px", marginLeft: "5px", filter: "brightness(0) invert(1)", cursor: "pointer", transform: sortConfig.key === col.key && sortConfig.direction === "desc" ? "rotate(180deg)" : "none", opacity: hoveredCol === col.key || sortConfig.key === col.key ? 1 : 0, transition: "opacity 0.2s" }}
                        />
                        <img
                          src={threedots}
                          alt="filter"
                          onClick={() => {
                            if (activeFilter === col.key) {
                              setActiveFilter(null);
                            } else {
                              setActiveFilter(col.key);
                              setFilterDraft(columnFilters[col.key] || { type: "Contains", value: "" });
                            }
                          }}
                          style={{ width: "14px", height: "14px", marginLeft: "5px", filter: "brightness(0) invert(1)", cursor: "pointer", opacity: hoveredCol === col.key || activeFilter === col.key || columnFilters[col.key] ? 1 : 0, transition: "opacity 0.2s" }}
                        />
                      </span>
                      {activeFilter === col.key && (
                        <div style={{ position: "absolute", top: "36px", left: "0", zIndex: 1000, background: "#fff", border: "1px solid #ccc", borderRadius: "4px", padding: "12px", minWidth: "200px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)" }}>
                          <select
                            className="form-control"
                            value={filterDraft.type}
                            onChange={(e) => updateFilterLive(col.key, { ...filterDraft, type: e.target.value })}
                            style={{ fontSize: "13px", marginBottom: "8px", appearance: "none", WebkitAppearance: "none", MozAppearance: "none", backgroundImage: `url(${chevrondown})`, backgroundRepeat: "no-repeat", backgroundPosition: "right 10px center", backgroundSize: "12px 12px", paddingRight: "30px" }}
                          >
                            {["Contains", "Not Contains", "Equals", "Not Equals", "Starts With", "Ends With", "Blank", "Not Blank"].map(opt => (
                              <option key={opt}>{opt}</option>
                            ))}
                          </select>
                          {!["Blank", "Not Blank"].includes(filterDraft.type) && (
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Filter..."
                              value={filterDraft.value}
                              onChange={(e) => updateFilterLive(col.key, { ...filterDraft, value: e.target.value })}
                              style={{ fontSize: "13px", marginBottom: "8px" }}
                            />
                          )}
                          <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
                            <span onClick={() => resetColumnFilter(col.key)} style={{ cursor: "pointer", color: "#707070", fontSize: "12px", fontWeight: "600" }}>RESET</span>
                            <span onClick={() => applyColumnFilter(col.key)} style={{ cursor: "pointer", color: "#810055", fontSize: "12px", fontWeight: "600" }}>APPLY</span>
                          </div>
                        </div>
                      )}
                      <div onMouseDown={(e) => handleMouseDown(e, col.key)} style={{ position: "absolute", right: 0, top: "25%", height: "50%", width: "2px", backgroundColor: "#a0a0a0", cursor: "col-resize" }}></div>
                    </th>
                  ))}
                  <th style={{ height: "36px", padding: "8px 10px", fontWeight: "400", whiteSpace: "nowrap", textAlign: "left", backgroundColor: godrejStyles.secondary, position: "sticky", right: 0, zIndex: 3 }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredEmployees.slice(currentPage * pageSize, (currentPage + 1) * pageSize).map(emp => (
                  <tr key={emp.es_salary_code} style={{ border: "1px solid #e0e0e0", backgroundColor: "#fff" }}>
                    {tableColumns.map((col, idx) => (
                      <td key={col.key} style={{ whiteSpace: "nowrap", textAlign: "left", padding: "8px 10px", borderTop: "1px solid #e0e0e0", borderBottom: "1px solid #e0e0e0", ...(idx === 0 ? { borderLeft: "1px solid #e0e0e0" } : {}) }}>{getCellValue(emp, col.key)}</td>
                    ))}
                    <td style={{ whiteSpace: "nowrap", textAlign: "left", padding: "8px 10px", border: "1px solid #e0e0e0", borderLeft: "none", position: "sticky", right: 0, backgroundColor: "#fff", zIndex: 1 }}>
                      <button 
                        onClick={() => viewLog(emp.es_salary_code)} 
                        className="btn btn-sm me-1" 
                        disabled={isLoadingLogs}
                        style={{ background: "none", border: "none", padding: 0, boxShadow: "none", opacity: isLoadingLogs ? 0.6 : 1 }}
                      >
                        <img 
                          src={eyeimg} 
                          alt={isLoadingLogs ? "Loading..." : "View Log"} 
                          title={isLoadingLogs ? "Loading logs..." : "View Signature Log"} 
                          style={{ width: "20px", height: "20px", cursor: isLoadingLogs ? "wait" : "pointer", filter: "invert(45%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(90%) contrast(90%)" }} 
                        />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div style={{ marginTop: '20px', backgroundColor: '#fff' }}>
            <div style={{ padding: '15px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span style={{ fontSize: '14px', color: '#707070' }}>Items per page</span>
                <input 
                  min="1" 
                  max="10"
                  type="number" 
                  value={pageSize}
                  onChange={(e) => {
                    const val = parseInt(e.target.value);
                    if (val >= 1 && val <= 10) {
                      setPageSize(val);
                      setCurrentPage(0);
                    }
                  }}
                  style={{
                    width: '60px',
                    height: '30px',
                    border: 'none',
                    borderBottom: '1px solid #000',
                    borderRadius: '0',
                    textAlign: 'center',
                    fontSize: '14px',
                    outline: 'none'
                  }}
                />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                <button 
                  type="button" 
                  onClick={() => setCurrentPage(currentPage - 1)}
                  disabled={currentPage === 0 || filteredEmployees.length === 0}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px',
                    padding: '8px 12px',
                    border: 'none',
                    background: 'transparent',
                    color: (currentPage === 0 || filteredEmployees.length === 0) ? '#ccc' : '#707070',
                    cursor: (currentPage === 0 || filteredEmployees.length === 0) ? 'not-allowed' : 'pointer',
                    fontSize: '14px'
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="18" height="18" fill="currentColor">
                    <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"></path>
                  </svg>
                  Previous
                </button>
                <div style={{ width: '1px', height: '30px', backgroundColor: '#e7e7e7' }}></div>
                <button 
                  type="button" 
                  onClick={() => setCurrentPage(currentPage + 1)}
                  disabled={currentPage >= numberOfPages() - 1 || filteredEmployees.length === 0}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px',
                    padding: '8px 12px',
                    border: 'none',
                    background: 'transparent',
                    color: (currentPage >= numberOfPages() - 1 || filteredEmployees.length === 0) ? '#ccc' : '#810055',
                    cursor: (currentPage >= numberOfPages() - 1 || filteredEmployees.length === 0) ? 'not-allowed' : 'pointer',
                    fontSize: '14px'
                  }}
                >
                  Next
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="18" height="18" fill="currentColor">
                    <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"></path>
                  </svg>
                </button>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ fontSize: '14px', color: '#707070' }}>You are on Page No.</span>
                  <select 
                    value={filteredEmployees.length > 0 ? currentPage + 1 : 1}
                    onChange={(e) => setCurrentPage(parseInt(e.target.value) - 1)}
                    disabled={filteredEmployees.length === 0}
                    style={{
                      padding: '5px 10px',
                      border: 'none',
                      borderRadius: '0',
                      fontSize: '14px',
                      minWidth: '60px',
                      backgroundColor: 'transparent',
                      outline: 'none'
                    }}
                  >
                    {filteredEmployees.length > 0 ? (
                      Array.from({ length: numberOfPages() }, (_, i) => (
                        <option key={i + 1} value={i + 1}>{i + 1}</option>
                      ))
                    ) : (
                      <option value={1}>1</option>
                    )}
                  </select>
                </div>
                <span style={{ fontSize: '14px', color: '#707070' }}>Total {filteredEmployees.length} Records</span>
              </div>
            </div>
          </div>
        </div>
      )}

      {filteredEmployees.length === 0 && (
        <div style={{ padding: '20px 10px', color: '#707070' }}>No record found</div>
      )}


    </div>
  );
}

export default AuditLog; 
